import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] border-t border-[#2a2a2a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div>
            <div className="relative h-10 w-40 mb-4">
              <Image
                src="https://da1mambadetailing.com/assets/ChatGPT%20Image%20Jul%205,%202025%20at%2011_23_17%20AM_1751750342289.png"
                alt="DA1MAMBA Professional Detailing logo"
                fill
                className="object-contain object-left"
                unoptimized
              />
            </div>
            <p className="text-[#9CA3AF] text-sm leading-relaxed mb-6">
              Mobile car detailing, paint correction, and ceramic coating for luxury and exotic vehicles. We come to you — Newport Beach, Irvine, and all of Orange County.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/da1mamba/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9CA3AF] hover:text-[#B8860B] transition-colors duration-200"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="https://www.facebook.com/da1mambadetailing"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9CA3AF] hover:text-[#B8860B] transition-colors duration-200"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@da1mamba"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9CA3AF] hover:text-[#B8860B] transition-colors duration-200"
                aria-label="TikTok"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.75a4.85 4.85 0 01-1.01-.06z"/>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@da1mamba"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9CA3AF] hover:text-[#B8860B] transition-colors duration-200"
                aria-label="YouTube"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-sm tracking-widest uppercase mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { label: 'Home', href: '/' },
                { label: 'Services', href: '/services' },
                { label: 'Gallery', href: '/gallery' },
                { label: 'About', href: '/about' },
                { label: 'Book Online', href: 'https://book.squareup.com/appointments/04o76ql3vbtxkz/location/LM68HVRDTDX7X/services', external: true },
                { label: 'Leave a Google Review', href: 'https://share.google/GDSnfBC9lym6FSYWm', external: true },
              ]?.map((link) => (
                <li key={link?.href}>
                  <Link
                    href={link?.href}
                    target={link?.external ? '_blank' : undefined}
                    rel={link?.external ? 'noopener noreferrer' : undefined}
                    className="text-[#9CA3AF] hover:text-[#B8860B] text-sm transition-colors duration-200"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-sm tracking-widest uppercase mb-6">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:+19492935721" className="text-[#9CA3AF] hover:text-white text-sm transition-colors duration-200 flex items-center gap-2">
                  <svg className="w-4 h-4 text-[#4B0082] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  (949) 293-5721
                </a>
              </li>
              <li>
                <a href="sms:9492935721" className="text-[#9CA3AF] hover:text-white text-sm transition-colors duration-200 flex items-center gap-2">
                  <svg className="w-4 h-4 text-[#4B0082] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                  Text for a Quote
                </a>
              </li>
              <li>
                <a href="mailto:info@da1mambadetailing.com" className="text-[#9CA3AF] hover:text-white text-sm transition-colors duration-200 flex items-start gap-2">
                  <svg className="w-4 h-4 text-[#4B0082] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span className="break-all">info@da1mambadetailing.com</span>
                </a>
              </li>
              <li>
                <a
                  href="https://book.squareup.com/appointments/04o76ql3vbtxkz/location/LM68HVRDTDX7X/services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#9CA3AF] hover:text-white text-sm transition-colors duration-200 flex items-center gap-2"
                >
                  <svg className="w-4 h-4 text-[#4B0082] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Book Online (Square)
                </a>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-[#2a2a2a]">
              <p className="text-[#9CA3AF] text-xs leading-relaxed">
                Serving Newport Beach, Irvine, Laguna Beach, Dana Point, Mission Viejo, Huntington Beach, and all of Orange County.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-[#2a2a2a] flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-[#9CA3AF] text-xs">
            &copy; 2025 DA1MAMBA Professional Detailing. All rights reserved.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center sm:justify-end">
            <Link href="/privacy-policy" className="text-[#9CA3AF] hover:text-[#B8860B] text-xs transition-colors duration-200">
              Privacy Policy
            </Link>
            <span className="text-[#2a2a2a]">|</span>
            <Link href="/terms-of-service" className="text-[#9CA3AF] hover:text-[#B8860B] text-xs transition-colors duration-200">
              Terms of Service
            </Link>
            <span className="text-[#2a2a2a] hidden sm:inline">|</span>
            <p className="text-[#9CA3AF] text-xs">
              Mobile Detailing &middot; Newport Beach &middot; Irvine &middot; Orange County
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}